module.exports = __webpack_public_path__ + "static/media/disclaimer-dark.0a4bdb71.svg";